var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMageBox3D({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.67083 2.63636L4.21208 5.66686C3.78606 5.90435 3.4314 6.25157 3.18492 6.67245C2.93845 7.09334 2.80917 7.57254 2.8105 8.06028V13.9398C2.80933 14.4274 2.9387 14.9064 3.18516 15.3271C3.43162 15.7478 3.7862 16.0949 4.21208 16.3323L9.67266 19.3637C10.0789 19.5897 10.536 19.7084 11.0009 19.7084C11.4658 19.7084 11.923 19.5897 12.3292 19.3637L17.7897 16.3332C18.2158 16.0957 18.5704 15.7485 18.8169 15.3276C19.0634 14.9067 19.1927 14.4275 19.1913 13.9398V8.06028C19.1925 7.5727 19.0631 7.09369 18.8167 6.67298C18.5702 6.25227 18.2156 5.90519 17.7897 5.66778L12.3292 2.63636C11.923 2.41033 11.4658 2.29169 11.0009 2.29169C10.536 2.29169 10.0789 2.41033 9.67266 2.63636H9.67083Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6358 6.41303L11 11M11 11L3.36414 6.41303M11 11V19.6992",
    stroke: "white",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMageBox3D);
export default __webpack_public_path__ + "static/media/mage_box-3d.a53e77800b5c852bfcc20ec14162d067.svg";
export { ForwardRef as ReactComponent };